import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    text: string;
    extendedStyles?: SmallHeadingAndTextStyles;
    isTrue?: boolean;
}

export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    extendedStyles?: SmallHeadingAndTextStyles;
    textStatus?: InjectableCss;
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 100%;
            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "legend",
        css:css`
        color: ${WhitecapColors.iconColor};
    font-size: 12px !important;
    text-transform: uppercase;
    font-weight: 400;

    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 10px !important;
                    display:none;
                `,
                css`
                font-size: 10px !important;
                display:none;

                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    textStatus: {
        css: css`
            width: 100%;
            font-size: 16px !important;
            color:${WhitecapColors.iconColor} !important;
font-style: normal;
    /* line-height:5px; */
    font-weight: 500;
    padding-top:3px;
    padding-bottom:3px;
    text-transform: capitalize;
    text-align:center !important;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 12px;
                `,
                css`
                font-size: 12px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    text: {
        css: css`
            width: 100%;
            font-size: 11px !important;
            color: ${WhitecapColors.white} !important;
font-style: normal;
    /* line-height:5px; */
    font-weight: 500;
    padding-top:3px;
    padding-bottom:3px;
    text-align:center !important;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 11px !important;
                `,
                css`
                font-size: 11px !important;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
};

const StatusLableAndHeading: React.FunctionComponent<OwnProps> = ({ heading, isTrue, text, extendedStyles, ...otherProps }) => {
    const [styles] = React.useState(() => mergeToNew(smallHeadingAndTextStyles, extendedStyles));
    //EC-676 - Mapping Of colors to the statuses
    const colorMapping: { [key: string]: string } = {
    "ordered": "#0C97ED",
    "shipped": "#0FAB29",
    "invoiced": "#FC9C0A",
    "paid": "#000000",
    "cancelled": "#D61C0F",
  };
  
  const getColor = (text: string): string => {
    return colorMapping[text] || colorMapping["ordered"];
  };

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps} >
            <Typography as="p" {...styles.heading} data-test-selector="heading">
                {heading}
            </Typography>
            {(isTrue && text ) ? <Typography as="p" {...styles.textStatus} data-test-selector={`text_${heading}`}>
                    {text}
                </Typography> : <StyledWrapper style={{ backgroundColor: getColor(text?.toLocaleLowerCase()), width:"115px", borderRadius: "13px" }}>
                {text && <Typography as="p" {...styles.text} data-test-selector={`text_${heading}`}>
                    {text}
                </Typography>}
            </StyledWrapper>}
        </StyledWrapper>
    );
};

export default StatusLableAndHeading;
